import React, { useEffect, useState } from 'react';
import { Section, SectionHeading, PRICE_EUR } from './Shared';
import { Pricing } from './Pricing';
import { VolumeCard } from './VolumeCard';
import { BonusShowcase } from './BonusShowcase';
import { tomos } from '../data/packContents';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-155" data-mp="1wqte5xrcky11">
      <div className="bg-brand-purpleDark text-brand-goldLight font-mono font-semibold text-2xl md:text-4xl rounded-sm px-4 md:px-6 py-2.5 md:py-3.5 min-w-[64px] md:min-w-[88px] text-center tabular-nums border border-brand-gold/40" data-id="element-156" data-mp="1wlgvqglrtri3">
        {fmt(value)}
      </div>
      <span className="font-seal text-[9px] md:text-[10px] uppercase tracking-seal text-brand-muted mt-2" data-id="element-157" data-mp="2ajyh47o7erwu">
        {label}
      </span>
    </div>;
  return <div className="max-w-3xl mx-auto mb-14" data-id="element-158" data-mp="2firttxvo2evy">
      <div className="glass-panel gold-frame rounded-sm p-6 md:p-10" data-id="element-159" data-mp="2ki4gahimljy0">
        <p className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark text-center mb-6" data-id="element-160" data-mp="2kg9t0wjvtfqr">
          Prezzo di lancio — si chiude tra
        </p>

        <div className="flex items-start justify-center gap-3 md:gap-5 mb-7" data-id="element-161" data-mp="2t9elj630f4ij">
          <TimeBox value={timeLeft.h} label="Ore" data-id="element-162" data-mp="2yakf164huvt4" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-163" data-mp="2y7y4qyq7y277">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Minuti" data-id="element-164" data-mp="136mcxnoamtpr" />
          <span className="text-2xl md:text-3xl text-brand-purpleDark/40 pt-2" data-id="element-165" data-mp="1375uh3a17g39">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Secondi" data-id="element-166" data-mp="y9cqmgw7ay65" />
        </div>

        <p className="text-center text-sm md:text-base text-brand-text/85 border-y border-brand-gold/30 py-3" data-id="element-167" data-mp="1cxh9plz61bpg">
          Il pack completo a{' '}
          <span className="text-brand-burgundy font-semibold" data-id="element-168" data-mp="183w9dna3o5n3">{PRICE_EUR}</span>{' '}
          — pagamento unico, accesso immediato dopo l’acquisto.
        </p>
      </div>
    </div>;
};
export const PackContents = () => <Section id="method" className="relative" data-id="element-169" data-mp="1vva05oslrt5y">
    <SectionHeading eyebrow="Cosa ricevi" className="mb-10" data-id="element-170" data-mp="1vtyzhxugf1j2">
      3 volumi principali + 5 bonus pratici inclusi
    </SectionHeading>

    <p className="text-center text-brand-text/70 text-base md:text-lg -mt-5 mb-10 font-display italic" data-id="element-171" data-mp="1qu4ay0y5io16">
      Oltre 300 pagine di contenuti visuali e operativi.
    </p>

    <div className="max-w-3xl mx-auto mb-16 space-y-3" data-id="element-172" data-mp="3sovb7ead84v6">
      {tomos.map(tomo => <VolumeCard key={tomo.n} tomo={tomo} data-id="element-173" data-mp="2859h91x0c6sv" />)}
    </div>

    <div className="max-w-5xl mx-auto" data-id="element-174" data-mp="287vot1jwemb3">
      <BonusShowcase data-id="element-175" data-mp="2d4vuhbcu5n1o" />
    </div>
  </Section>;
export const MethodOverview = () => <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-176" data-mp="1yfzmfeas4a12">
    <LaunchUrgency data-id="element-177" data-mp="1ydnabhrpctvx" />
    <Pricing data-id="element-178" data-mp="23et1hb5ps93c" />
  </div>;